import React from 'react';

import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles({
	container : {
        position: "relative",
        top: 0,
        left: 0,
        flex:1,
        display:"block",
         margin:"auto"
    },
    mainImage: {
         position: "relative",
         minWidth:'90%'
         //top: 0,
         //left: 0,
         //border: "1px red solid"
    },
    pinImage: {
            position: "absolute",
            //border: "1px green solid",
    },
    
  });
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);
const PicMap = (props) =>{
    const pinFixWidth = 20;
	const {
		imgmain,
		pins
	} = props;
	var adjsCount=0;
	const [adjPins, setAdjPins] = React.useState(pins);

	if(pins.length !== adjPins.length){
		setAdjPins([...pins]);
		adjsCount=pins.length;
	 }

	 const onImgLoad = pid => ({target:img_url}) => {
		adjustPosition(pid,img_url);
	  }
	  const adjustPosition = (pid,img_url)=>{
		adjsCount +=1;
		var pin = adjPins.find(x => x.id === pid);
		pin.pos_x -= (img_url.width/2);
		pin.pos_y -= (img_url.height);
		if(adjsCount === adjPins.length){
		  setAdjPins([...adjPins]);
		}
	  }  
	const classes = useStyles();

	return (
		<div className={classes.container}>
                <img className={classes.mainImage} src={imgmain}/>
                {adjPins.map((pin) => {
                  return(
                      <HtmlTooltip key={pin.id}
                      title={
                        <React.Fragment>
						  <Typography color="inherit">{pin.description}</Typography>
						  </React.Fragment>
                      }
                    >
                <img  onLoad={onImgLoad(pin.id)} className={classes.pinImage} src={window.$ImageBaseUrl+"/"+pin.img_url} style={{top:pin.pos_y,left:pin.pos_x,width:20}} />
                </HtmlTooltip>
                  )
                })}
                </div>
	)

}

export default PicMap